'use client';

import { Flex } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import HeaderFixed from './header-fixed';
import { HeaderStatic } from './header-static';
import { IShipper } from '@/_types';

interface RestaurantHeaderProps {
  brand: IShipper | null;
}

const RestaurantHeader = ({ brand }: RestaurantHeaderProps) => {
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [isFixedVisible, setIsFixedVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => setIsFixedVisible(!entry.isIntersecting),
      { threshold: 0 }
    );

    if (headerRef.current) obs.observe(headerRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      {/* Main header (observed) */}
      <div ref={headerRef}>
        <HeaderStatic brand={brand} />
      </div>

      {/* Fixed header when scrolling */}
      <Flex
        position="fixed"
        top={0}
        left={0}
        right={0}
        zIndex={isFixedVisible ? 20 : 0}
        bg="white"
        opacity={isFixedVisible ? 1 : 0}
        transform={isFixedVisible ? 'translateY(0)' : 'translateY(-100%)'}
        transition="all 300ms ease"
      >
        <HeaderFixed />
      </Flex>
    </>
  );
};

export default RestaurantHeader;
